import { SKIP_SYMBOL } from '../components/CycleTable/constants';
import CycleMeasurement from '../enums/cycle-measurement';
import { convertTemperatureDelta } from './temperature-unit-conversion';

// deltaT is a temperature DIFFERENCE (e.g. |setpoint - present|), not an
// absolute reading - converting it needs the delta formula (*9/5, no +32
// offset), not getValidTemperature/getTempByMeasurement's absolute one.
const getValidDeltaTemperature = (
  delta: number | string | undefined,
  measurement: CycleMeasurement,
  skipValue: string = SKIP_SYMBOL,
) => {
  if (typeof delta !== 'number') {
    return skipValue;
  }

  return Number(convertTemperatureDelta(delta, CycleMeasurement.Celsius, measurement));
};

export default getValidDeltaTemperature;
